import React from "react"

const EditBaseHeader = ({ fontSize = 15 }) => (
  <div style={{ margin: '15px 0', fontSize: fontSize }}>

  <h3>Editar a base</h3>
  <p>Você pode editar um registro da base de dados atual na listagem a seguir.</p>
  
  </div>
)

export default EditBaseHeader
